/**
 * TEAM ACCESS SERVICE (#338)
 * ==========================
 *
 * Vérifie l'appartenance équipe via la Cloud Function `checkTeamAccess`
 * (europe-west1). La whitelist vit CÔTÉ SERVEUR (param TEAM_ACCESS_EMAILS,
 * functions/.env.befret-<env>) — le front ne reçoit qu'un oui/non, jamais
 * la liste. Remplace `environment.teamEmails` qui était compilée dans le
 * bundle public (fuite PII).
 *
 * Le résultat est mis en cache par uid pour la durée de la session Angular
 * (le guard team-only tourne sur quasi toutes les routes en dev/acc) ; un
 * échec réseau n'est PAS mis en cache (fail-closed, retenté à la prochaine
 * navigation).
 */

import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

interface CheckTeamAccessResponse {
  allowed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class TeamAccessService {

  private cache = new Map<string, boolean>();

  constructor(private functions: Functions) {}

  /**
   * True si le compte connecté est membre de l'équipe (email @befret.be ou
   * whitelist serveur). L'uid ne sert que de clé de cache : la CF lit l'email
   * sur le token Auth vérifié, pas depuis un paramètre client.
   */
  async isTeamMember(uid: string): Promise<boolean> {
    const cached = this.cache.get(uid);
    if (cached !== undefined) {
      return cached;
    }

    try {
      const call = httpsCallable<unknown, CheckTeamAccessResponse>(this.functions, 'checkTeamAccess');
      const result = await call({});
      const allowed = !!result.data?.allowed;
      this.cache.set(uid, allowed);
      return allowed;
    } catch (error) {
      console.error('❌ [TeamAccess] checkTeamAccess indisponible — accès refusé (fail-closed):', error);
      return false;
    }
  }
}
